export const PROPERTY_MEDIA_MANAGER = "propertyMediaManager";

export function sortPropertyImages(images) {
  const source = Array.isArray(images) ? images.slice() : [];
  return source.sort((a, b) => {
    const pa = Number.isFinite(Number(a && a.position)) ? Number(a.position) : 0;
    const pb = Number.isFinite(Number(b && b.position)) ? Number(b.position) : 0;
    if (pa !== pb) return pa - pb;
    const ia = Number(a && a.id) || 0;
    const ib = Number(b && b.id) || 0;
    return ia - ib;
  });
}

export function applyCanonicalRows(current, kind, rows) {
  const previous = Array.isArray(current) ? current : [];
  const others = previous.filter((img) => img.kind !== kind);
  const ordered = sortPropertyImages(rows || []).map((row) => ({ ...row, kind }));
  if (kind === "image") {
    return [...ordered, ...others.filter((img) => img.kind === "plan")];
  }
  const photos = previous.filter((img) => img.kind === "image");
  return [...photos, ...ordered];
}

export const REORDER_ERROR_MESSAGE = "Не вдалося зберегти порядок. Спробуйте ще раз.";
export const DELETE_ERROR_MESSAGE = "Не вдалося видалити зображення.";
